import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { db } from "@/lib/db-client";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { audit } from "@/lib/audit-client";

export const Route = createFileRoute("/_authenticated/admin/clients")({
  component: ClientsAdmin,
});

function ClientsAdmin() {
  const [rows, setRows] = useState<any[]>([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const load = () => db.from("clients").select("*").order("name").then(({ data }) => setRows(data ?? []));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name) return;
    const { data, error } = await db.from("clients").insert({ name, billing_email: email }).select().single();
    if (error) return toast.error(error.message);
    await audit("client.create", { entity: "clients", entity_id: data?.id, metadata: { name, billing_email: email } });
    setName(""); setEmail(""); load();
  };
  const update = async (id: string, patch: any) => {
    const { error } = await db.from("clients").update(patch).eq("id", id);
    if (error) return toast.error(error.message);
    await audit("client.update", { entity: "clients", entity_id: id, metadata: { changes: patch } });
    load();
  };
  const remove = async (id: string) => {
    if (!confirm("Supprimer ce client ?")) return;
    const { error } = await db.from("clients").delete().eq("id", id);
    if (error) return toast.error(error.message);
    await audit("client.delete", { entity: "clients", entity_id: id });
    load();
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Clients</h1>
      <Card><CardContent className="p-4 flex flex-col sm:flex-row gap-2">
        <Input placeholder="Nom du client" value={name} onChange={(e) => setName(e.target.value)} />
        <Input placeholder="Email facturation" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <Button onClick={add}><Plus className="h-4 w-4 mr-1" /> Ajouter</Button>
      </CardContent></Card>
      <Card><CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow><TableHead>Nom</TableHead><TableHead>Email</TableHead><TableHead>Actif</TableHead><TableHead /></TableRow>
          </TableHeader>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.id}>
                <TableCell>
                  <Input defaultValue={r.name} onBlur={(e) => e.target.value !== r.name && update(r.id, { name: e.target.value })} />
                </TableCell>
                <TableCell>
                  <Input defaultValue={r.billing_email} type="email" onBlur={(e) => e.target.value !== r.billing_email && update(r.id, { billing_email: e.target.value })} />
                </TableCell>
                <TableCell>
                  <Switch checked={r.active} onCheckedChange={(v) => update(r.id, { active: v })} />
                </TableCell>
                <TableCell>
                  <Button variant="ghost" size="icon" onClick={() => remove(r.id)}><Trash2 className="h-4 w-4" /></Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
